"use strict";
function supportsFeatures() {
    // :where() is the strictest requirement — implied by Design library CSS-in-JS (Chrome 88+, Safari 14+, Firefox 78+)
    return typeof CSS === 'object' && CSS.supports('selector(:where(a))');
}
function blockOldIOS() {
    const match = navigator.userAgent.match(/OS (\d+)_/);
    if (match && Number(match[1]) < 14) {
        return true;
    }
    return false;
}
// iPads in "Request Desktop Website" mode spoof a macOS user agent,
// breaking iOS version detection. WebKit/605.1.15 frozen in that UA is the tell.
function isSpoofedIPad() {
    const ua = navigator.userAgent;
    return ua.includes('Macintosh') && ua.includes('AppleWebKit/605.1.15') && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
}
function featureStatus() {
    const iosMatch = navigator.userAgent.match(/OS (\d+)_/);
    const iosVersion = iosMatch ? Number(iosMatch[1]) : null;
    return [
        { label: 'CSS :where() (Design library)', ok: typeof CSS === 'object' && CSS.supports('selector(:where(a))') },
        { label: `iOS version (${iosVersion !== null && iosVersion !== void 0 ? iosVersion : 'n/a'})`, ok: iosVersion === null || iosVersion >= 14 },
        { label: 'User agent', ok: true, value: navigator.userAgent },
    ];
}
function showMessage(message, steps) {
    document.documentElement.classList.add('browser-unsupported');
    document.body.innerHTML = '';
    const main = document.createElement('main');
    main.style.fontFamily = '"Helvetica Neue", Arial, sans-serif';
    main.style.minHeight = '100vh';
    main.style.display = 'flex';
    main.style.flexDirection = 'column';
    main.style.justifyContent = 'center';
    main.style.alignItems = 'center';
    main.style.textAlign = 'center';
    main.style.padding = '2rem';
    main.style.background = '#060912';
    main.style.color = '#fff';
    const wrapper = document.createElement('div');
    const heading = document.createElement('h1');
    heading.textContent = 'Browser not supported';
    const text = document.createElement('p');
    text.textContent = message;
    wrapper.appendChild(heading);
    wrapper.appendChild(text);
    if (steps && steps.length > 0) {
        const ol = document.createElement('ol');
        ol.style.textAlign = 'left';
        ol.style.marginTop = '1.5rem';
        ol.style.paddingLeft = '1.5rem';
        ol.style.lineHeight = '2';
        steps.forEach(step => {
            const li = document.createElement('li');
            li.textContent = step;
            ol.appendChild(li);
        });
        wrapper.appendChild(ol);
    }
    main.appendChild(wrapper);
    const debug = document.createElement('div');
    debug.style.marginTop = '3rem';
    debug.style.fontSize = '11px';
    debug.style.opacity = '0.45';
    debug.style.textAlign = 'left';
    debug.style.lineHeight = '1.8';
    debug.style.maxWidth = '480px';
    debug.style.wordBreak = 'break-all';
    featureStatus().forEach(({ label, ok, value }) => {
        const row = document.createElement('div');
        row.textContent = `${ok ? '✓' : '✗'} ${label}${value ? ': ' + value : ''}`;
        if (!ok)
            row.style.color = '#ff6b6b';
        debug.appendChild(row);
    });
    main.appendChild(debug);
    document.body.appendChild(main);
}
if (!supportsFeatures()) {
    if (isSpoofedIPad()) {
        showMessage('This site requires Safari on iPad. "Request Desktop Website" is currently enabled which prevents the app from loading.', [
            'Open Settings on your iPad',
            'Scroll down and tap Safari',
            'Tap "Request Desktop Website"',
            'Turn off "All Websites"',
            'Reload this page',
        ]);
        throw new Error('Unsupported: iPad desktop mode');
    }
    showMessage('Your browser does not support all required features. Please update version or use a different browser.');
    throw new Error('Unsupported browser');
}
if (blockOldIOS()) {
    showMessage('iOS 14 or later is required. Please upgrade your device or use another browser.');
    throw new Error('Unsupported iOS');
}
